import { defineNuxtPlugin } from "#imports";
import { isBrowser } from "~/constants";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("page:finish", () => {
    if (isBrowser) {
      if (!location.hash || location.hash === "#") {
        document.body.scrollTo({ top: 0 });
      } else {
        document
          .querySelector(location.hash)
          ?.scrollIntoView({ behavior: "smooth" });
      }
    }
  });
});
